// Platform admin = the "Super Admin" role with no owning organisation (mirrors backend user_has_cross_org_access).
// An organisation's own Super Admin is not a platform admin. Used for pages only the platform team may see.
export function isPlatformAdmin(user) {
  return !!user && user.role_name === 'Super Admin' && !user.org_id;
}
